import { InjectionToken } from '@angular/core';

export const SCROLL_SERVICE: InjectionToken<IScrollService> = new InjectionToken<IScrollService>('SCROLL_SERVICE');

export interface IScrollService {
	scrollToElement(elementId: string): void;
}
